import mrtAxiosV2, { MrtAxiosOptions } from '../utils/mrtAxiosV2';
import { SearchOffersResponse } from '../types/globalSearch';
import DomainManager from '../utils/DomainManager';

export const fetchSearchOffers = (word: string, targetEnv: string, options?: MrtAxiosOptions) => {
  const { isWebView } = options || {};
  const domainManager = new DomainManager(targetEnv);

  return mrtAxiosV2(targetEnv, { isWebView }).get<SearchOffersResponse>(
    `${domainManager.getApiDomain()}/search/offers/v1/ac/${word}`,
  );
};
